<template>
  <div>
    <div class="tab-bar-placeholder"></div>
    <div class="tab-bar" id="ch-tab-bar">
      <div class="item">
        <router-link to="courses">
          <span class="iconfont icon-calendar"></span>
          <p>课程</p>
        </router-link>
      </div><div class="item">
        <router-link to="activities">
          <span class="iconfont icon-activity-line"></span>
          <p>活动</p>
        </router-link>
      </div><div class="item">
        <router-link to="profile">
          <span class="iconfont icon-gerenzhongxin"></span>
          <p>我的</p>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tab-bar',
  components: {
  },
  data() {
      return {};
  },
}

</script>

<style lang="scss" scoped>
  .tab-bar-placeholder{height:100px;}
  .tab-bar{
    position:fixed;left:0;right:0;bottom:0;height:100px;font-size:28px;
    background: #fff;
    border-top: solid 1px #e2e4ea;
    text-align: center;
    z-index: 2;

    .item {
      width: 33%;
      display: inline-block;
      padding: 15px 0 0;
    }

    a {
      color: #393a39;
      text-decoration: none;
    }
    p {
      margin-top: 6px;
      font-size:24px;
    }
    .iconfont {
      font-size:36px;
    }
    .router-link-active {
      color: #f26522;
    }
  }
</style>

